import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'weekEndDelta'})
export class WeekEndDeltaPipe implements PipeTransform {
    transform(value, delta) {
        let date = new Date(value);
        let day = date.getDay();
        let diff = date.getDate() + (delta * 7) - day + (day === 0 ? -2 : 5);
        return date.setDate(diff);
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/WeekEndDeltaPipe.ts